/* eslint-disable no-unused-vars */
export type ChartBarOptions = {
  chart: {
    id: string
  },
  xaxis: {
    categories: string[]
  }
}

export type ChartBarSeries = {
  name: string,
  data: number[]
}

export const greenColors: string[] = ['#06BAB2', '#098C86', '#9FFCF8', '#C7EBEB']
export const labelGreenColors: string[] = ['#4B4B4B', '#ffffff', '#ffffff', '#ffffff']

export const redColors: string[] = ['#EF6167', '#BE373D', '#FFADB1', '#FFDCDE']
export const labelRedColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const blueColors: string[] = ['#2D4054', '#17222F', '#6494C6', '#9ED6EE']
export const labelBlueColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const greyColors: string[] = ['#787878', '#4B4B4B', '#999999', '#B6B6B6']
export const labelGreyColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const orangeColors: string[] = ['#FF922B', '#E37B00', '#FFC888', '#FF9F40']
export const labelOrangeColors: string[] = ['#ffffff', '#ffffff', '#ffffff', '#ffffff']

export const primaryColors: string[] = ['#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5']
export const labelPrimaryColors: string[] = ['white', '#3f51b5', '#3f51b5', '#3f51b5']

export const rainbowColors: string[] = ['#dee2ff', '#4cc9f0', '#f72585', '#023047', '#24842C', '#d62828', '#FFB703', '#ffc8dd', '#70e000', '#540b0e']
export const labelRainbowColors: string[] = ['#000214', '#020F13', '#140109', '#ffffff', '#ffffff', '#ffffff', '#291D00', '#3D0017', '#0A1400', '#FADBDC']

export const multiColors: string[] = ['#26A0FC', '#26E7A6', '#8B75D7', '#FEBC3B', '#FF6178']
export const labelMultiColors: string[] = ['#070707', '#070707', '#02011B', '#070707', '#050506']

export const twoColors: string[] = ['#54EBD0', '#FF0007']
export const labelTwoColors: string[] = ['#0B180C', '#180000']

export enum ChartBarThemes {
  default = 'green',
  green = 'green',
  red = 'red',
  blue = 'blue',
  grey = 'grey',
  orange = 'orange',
  primary = 'primary',
  rainbow = 'rainbow',
  twocolors = 'twocolors',
  multi = 'multi'
}

export type ChartBarTheme = {
  [ChartBarThemes.default]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.green]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.red]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.blue]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.grey]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.primary]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.orange]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.rainbow]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.twocolors]: {
    seriesColors: string[]
    labelsColors: string[]
  },
  [ChartBarThemes.multi]: {
    seriesColors: string[]
    labelsColors: string[]
  }
}

export const themes: ChartBarTheme = {
  [ChartBarThemes.default]: {
    seriesColors: greenColors,
    labelsColors: labelGreenColors
  },
  [ChartBarThemes.green]: {
    seriesColors: greenColors,
    labelsColors: labelGreenColors
  },
  [ChartBarThemes.red]: {
    seriesColors: redColors,
    labelsColors: labelRedColors
  },
  [ChartBarThemes.blue]: {
    seriesColors: blueColors,
    labelsColors: labelBlueColors
  },
  [ChartBarThemes.grey]: {
    seriesColors: greyColors,
    labelsColors: labelGreyColors
  },
  [ChartBarThemes.primary]: {
    seriesColors: primaryColors,
    labelsColors: labelPrimaryColors
  },
  [ChartBarThemes.orange]: {
    seriesColors: orangeColors,
    labelsColors: labelOrangeColors
  },
  [ChartBarThemes.rainbow]: {
    seriesColors: rainbowColors,
    labelsColors: labelRainbowColors
  },
  [ChartBarThemes.twocolors]: {
    seriesColors: twoColors,
    labelsColors: labelTwoColors
  },
  [ChartBarThemes.multi]: {
    seriesColors: multiColors,
    labelsColors: labelMultiColors
  }
}
